import axios, {
  AxiosInstance,
  AxiosError,
  InternalAxiosRequestConfig,
} from 'axios';
import { Config } from '../config';
import { authAPI } from './axiosIndex';
import { SignInDto } from '../model/user.dto';

// 타입 정의
interface CustomAxiosError extends AxiosError {
  config: InternalAxiosRequestConfig & { _retry?: boolean };
}

// 토큰이 필요없는 인스턴스
const publicApi: AxiosInstance = axios.create({
  baseURL: Config.API_URL,
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 토큰이 필요한 인스턴스
const api: AxiosInstance = axios.create({
  baseURL: Config.API_URL,
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request 인터셉터
api.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = sessionStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  },
);

// Response 인터셉터
api.interceptors.response.use(
  (response) => response,
  async (error: any) => {
    if (error.response.data.statusCode === 401 && !error.config._retry) {
      error.config._retry = true;

      try {
        const refreshToken = sessionStorage.getItem('refreshToken');
        const response = await authAPI.getNewToken(String(refreshToken));

        const { accessToken } = response.data;
        sessionStorage.setItem('accessToken', accessToken);

        error.config.headers.Authorization = `Bearer ${accessToken}`;
        return api(error.config);
      } catch (refreshError) {
        const userInfor = JSON.parse(String(localStorage.getItem('userInfor')));

        if (userInfor) {
          const dto: SignInDto = {
            passid: userInfor.passid,
            password: userInfor.password,
          };

          const token = await authAPI.signIn(dto);

          sessionStorage.setItem('accessToken', token.data.accessToken);
          sessionStorage.setItem('refreshToken', token.data.refreshToken);
          sessionStorage.setItem(
            'accessExpire',
            (Date.now() + token.data.accessExpire * 1000).toString(),
          );
          sessionStorage.setItem(
            'refreshExpire',
            (Date.now() + token.data.refreshExpire * 1000).toString(),
          );

          error.config.headers.Authorization = `Bearer ${token.data.accessToken}`;
          return api(error.config);
        } else {
          localStorage.clear();
          sessionStorage.clear();
        }
      }
    }
    return Promise.reject(error);
  },
);

export { api, publicApi };
